/**
 * Product card ATC: add first available variant to cart. If no variant (sold out) -> go to product page.
 * Use on .product-card__cart-btn with data-product-url, data-variant-id (when available).
 */
(function () {
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var PUB_SUB = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : { cartUpdate: 'cart-update', cartError: 'cart-error' };

  function handleClick(evt) {
    var btn = evt.target.closest('.product-card__cart-btn');
    if (!btn || btn.hasAttribute('aria-disabled')) return;

    var url = btn.getAttribute('data-product-url');
    var variantId = btn.getAttribute('data-variant-id');

    if (!url) return;

    if (!variantId) {
      window.location.href = url;
      return;
    }

    if (typeof window.routes === 'undefined' || typeof window.fetchConfig !== 'function') {
      window.location.href = url;
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    if (btn.classList.contains('loading')) return;

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    // Same request as product-form: FormData with id, quantity, sections (array), sections_url
    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', window.routes.cart_add_url);
    var idInput = document.createElement('input');
    idInput.setAttribute('name', 'id');
    idInput.setAttribute('value', variantId);
    var qtyInput = document.createElement('input');
    qtyInput.setAttribute('name', 'quantity');
    qtyInput.setAttribute('value', '1');
    form.appendChild(idInput);
    form.appendChild(qtyInput);

    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }

    var config = window.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB.cartError, {
              source: 'product-card-atc',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message
            });
          }
          if (response.message) alert(response.message);
          return;
        }
        if (!cart) {
          window.location.href = window.routes.cart_url;
          return;
        }
        // Same as product-form: publish then renderContents (no quick-add branch)
        if (typeof publish === 'function') {
          publish(PUB_SUB.cartUpdate, {
            source: 'product-card-atc',
            productVariantId: variantId,
            cartData: response
          });
        }
        if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measure === 'function') {
          CartPerformance.measure('add:paint-updated-sections', function () {
            cart.renderContents(response);
          });
        } else {
          cart.renderContents(response);
        }
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }

  function handleImageWrapperClick(evt) {
    var wrapper = evt.target.closest('.product-card__image-wrapper--clickable');
    if (!wrapper) return;
    if (evt.target.closest('.product-card__cart-btn') || evt.target.closest('.product-card__actions') || evt.target.closest('button')) return;
    var url = wrapper.getAttribute('data-product-url');
    if (url) window.location.href = url;
  }

  function handleImageWrapperKeydown(evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    var wrapper = evt.target.closest('.product-card__image-wrapper--clickable');
    if (!wrapper) return;
    if (evt.target.closest('.product-card__cart-btn') || evt.target.closest('.product-card__actions') || evt.target.closest('button')) return;
    evt.preventDefault();
    var url = wrapper.getAttribute('data-product-url');
    if (url) window.location.href = url;
  }

  document.body.addEventListener('click', handleClick, true);
  document.body.addEventListener('click', handleImageWrapperClick);
  document.body.addEventListener('keydown', handleImageWrapperKeydown);
})();
